import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class TodoService {
  /**
   * Constructor
   * @param {HttpClientService} private httpClient A wrapper for angular's http with some default calls
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Backend base URL for this service
   * @type {String}
   */
  private url = 'events';

  /**
   * Add a day to the todo start
   * @param  {any}          todo Todo to add a day
   * @return {Promise<any>}      Response indicating result
   */
  addADay(todo: any): Promise<any> {
    return this.httpClient.put(`${this.url}/${todo.id}.json`, { add_a_day: true, start: todo.start });
  }

  // TODO: To be removed after usage is removed
  /**
   * Create a new Todo
   * @param  {any}          todo todo params
   * @return {Promise<any>}      Returns a standard response indicating result
   */
  createTodo(todo: any): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { angular: 2, new_todo: todo });
  }

  /**
   * Get Todos for a particular matter
   * @param  {number}       matter_id Id of matter
   * @param  {boolean}      showInactive Filter for inactive todos
   * @return {Promise<any>}           Response containing todos
   */
  getMatterTodos(matter_id: number, showInactive: boolean = false): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, {
      angular: 1,
      matter_id: matter_id,
      only_current: 0,
      show_inactive: showInactive ? 1 : 0,
      todos_only: true,
      for_matters_page: true,
    });
  }

  /**
   * Get Todos for logged in user
   * @return {Promise<any>} Response containing todos
   */
  getTodos(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { angular: 1, todos_only: 1, only_current: 1, matter_id: null });
  }

  /**
   * Mark a todo as complete
   * @param  {any}          todo Todo to mark complete
   * @return {Promise<any>}      Response indicating result
   */
  markCompleted(todo: any): Promise<any> {
    return this.httpClient.put(`${this.url}/${todo.id}.json`, { deactivate: true });
  }

  /**
   * Update order of todos
   * @param  {Array<number>} positions Positions of todos
   * @return {Promise<any>}            Returns a standard response indicating result
   */
  updatePosition(positions: Array<number>): Promise<any> {
    return this.httpClient.post(`${this.url}/update_todo_positions.json`, { angular: 1, positions: positions });
  }
}
